(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voy-coming-soon"] && !Shopify.designMode) return;
  try {
    
  class VoyKlaviyoSignup extends HTMLElement {
    #controller = null;
    #form = null;
    #field = null;
    #email = null;
    #honeypot = null;
    #message = null;
    #submit = null;
    #submitLabel = '';

    connectedCallback() {
      this.#form = this.querySelector('[data-voy-klaviyo-form]');
      this.#field = this.querySelector('[data-voy-klaviyo-field]');
      this.#email = this.querySelector('input[type="email"]');
      this.#honeypot = this.querySelector('[data-voy-klaviyo-honeypot]');
      this.#message = this.querySelector('[data-voy-klaviyo-message]');
      this.#submit = this.querySelector('[data-voy-klaviyo-submit]');
      this.#submitLabel = this.#submit?.textContent.trim() || '';

      this.#form?.addEventListener('submit', this.#handleSubmit);
    }

    disconnectedCallback() {
      this.#controller?.abort();
      this.#form?.removeEventListener('submit', this.#handleSubmit);
    }

    #handleSubmit = async (event) => {
      event.preventDefault();

      if (!this.#email || !this.#submit) return;

      if (!this.#email.validity.valid) {
        this.#email.setAttribute('aria-invalid', 'true');
        this.#field?.classList.add('voy-coming-soon__field--error');
        this.#setMessage(this.dataset.invalidMessage, true);
        this.#email.focus();
        return;
      }

      if (this.#honeypot?.value) {
        this.#form?.reset();
        this.#setMessage(this.dataset.successMessage, false);
        return;
      }

      if (!this.dataset.klaviyoSiteId || !this.dataset.klaviyoListId) {
        this.#setMessage(this.dataset.errorMessage, true);
        return;
      }

      this.#controller?.abort();
      this.#controller = new AbortController();
      this.#setLoading(true);
      this.#email.setAttribute('aria-invalid', 'false');
      this.#field?.classList.remove('voy-coming-soon__field--error');
      this.#setMessage('', false);

      const endpoint = new URL('https://a.klaviyo.com/client/subscriptions');
      endpoint.searchParams.set('company_id', this.dataset.klaviyoSiteId);

      const payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'VOY Coming Soon Page',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: this.#email.value.trim(),
                  properties: {
                    'Signup Source': 'Coming Soon Page',
                    'Consent Scope': 'Launch Notifications',
                    'Form Version': 'Launch 2026'
                  },
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: this.dataset.klaviyoListId
              }
            }
          }
        }
      };

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
            revision: '2026-07-15'
          },
          body: JSON.stringify(payload),
          signal: this.#controller.signal
        });

        if (!response.ok) throw new Error(`Klaviyo request failed with status ${response.status}`);

        this.#form?.reset();
        this.#setMessage(this.dataset.successMessage, false);
        this.#message?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name === 'AbortError') return;

        this.#email.setAttribute('aria-invalid', 'true');
        this.#field?.classList.add('voy-coming-soon__field--error');
        this.#setMessage(this.dataset.errorMessage, true);
      } finally {
        this.#setLoading(false);
      }
    };

    #setLoading(isLoading) {
      if (!this.#submit) return;

      this.#submit.disabled = isLoading;
      this.#submit.textContent = isLoading ? this.dataset.loadingMessage : this.#submitLabel;
      this.#form?.setAttribute('aria-busy', String(isLoading));
    }

    #setMessage(message, isError) {
      if (!this.#message) return;

      this.#message.textContent = message || '';
      this.#message.hidden = !message;
      this.#message.setAttribute('role', isError ? 'alert' : 'status');
      this.#message.tabIndex = -1;
    }
  }

  if (!customElements.get('voy-klaviyo-signup')) {
    customElements.define('voy-klaviyo-signup', VoyKlaviyoSignup);
  }

  class VoyStillWave extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      this.image = this.querySelector('.voy-coming-soon__image');
      this.canvas = this.querySelector('.voy-coming-soon__wave');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      if (!this.image || !this.canvas || this.dataset.waveEffect !== 'true' || this.reducedMotion.matches) return;

      const initialize = () => this.#initializeWave();

      if (this.image.complete && this.image.naturalWidth > 0) {
        this.image.decode().catch(() => {}).then(initialize);
        return;
      }

      this.image.addEventListener('load', initialize, {
        once: true,
        signal: this.abortController.signal,
      });
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
      window.cancelAnimationFrame(this.animationFrame);
    }

    #initializeWave() {
      if (this.animationFrame) return;

      const gl = this.canvas.getContext('webgl', {
        alpha: false,
        antialias: false,
        powerPreference: 'high-performance',
      });

      if (!gl) return;

      try {
        const floatTexture = gl.getExtension('OES_texture_float');
        const linearFloatTexture = gl.getExtension('OES_texture_float_linear');

        if (!floatTexture) return;

        const vertexSource = `
          attribute vec2 a_position;
          varying vec2 v_uv;

          void main() {
            v_uv = a_position * 0.5 + 0.5;
            gl_Position = vec4(a_position, 0.0, 1.0);
          }
        `;
        const dropProgram = this.#createProgram(
          gl,
          vertexSource,
          `
            precision highp float;

            const float PI = 3.141592653589793;
            uniform sampler2D u_texture;
            uniform vec2 u_center;
            uniform float u_radius;
            uniform float u_strength;
            varying vec2 v_uv;

            void main() {
              vec4 info = texture2D(u_texture, v_uv);
              float drop = max(0.0, 1.0 - length(u_center - v_uv) / u_radius);
              drop = 0.5 - cos(drop * PI) * 0.5;
              info.r += drop * u_strength;
              gl_FragColor = info;
            }
          `,
        );
        const updateProgram = this.#createProgram(
          gl,
          vertexSource,
          `
            precision highp float;

            uniform sampler2D u_texture;
            uniform vec2 u_delta;
            varying vec2 v_uv;

            void main() {
              vec4 info = texture2D(u_texture, v_uv);
              vec2 dx = vec2(u_delta.x, 0.0);
              vec2 dy = vec2(0.0, u_delta.y);
              float average = (
                texture2D(u_texture, v_uv - dx).r +
                texture2D(u_texture, v_uv - dy).r +
                texture2D(u_texture, v_uv + dx).r +
                texture2D(u_texture, v_uv + dy).r
              ) * 0.25;

              info.g += (average - info.r) * 2.0;
              info.g *= 0.995;
              info.r += info.g;
              gl_FragColor = info;
            }
          `,
        );
        const renderProgram = this.#createProgram(
          gl,
          vertexSource,
          `
            precision highp float;

            uniform sampler2D u_image;
            uniform sampler2D u_ripples;
            uniform vec2 u_delta;
            uniform vec2 u_container_ratio;
            uniform float u_perturbance;
            uniform float u_viewport_aspect;
            uniform float u_image_aspect;
            uniform vec2 u_focal_point;
            varying vec2 v_uv;

            vec2 coverUv(vec2 uv) {
              if (u_viewport_aspect > u_image_aspect) {
                uv.y = u_focal_point.y + (uv.y - 0.5) * (u_image_aspect / u_viewport_aspect);
              } else {
                uv.x = u_focal_point.x + (uv.x - 0.5) * (u_viewport_aspect / u_image_aspect);
              }

              return uv;
            }

            void main() {
              vec2 rippleUv = (v_uv - 0.5) * u_container_ratio + 0.5;
              float height = texture2D(u_ripples, rippleUv).r;
              float heightX = texture2D(u_ripples, rippleUv + vec2(u_delta.x, 0.0)).r;
              float heightY = texture2D(u_ripples, rippleUv + vec2(0.0, u_delta.y)).r;
              vec3 dx = vec3(u_delta.x, heightX - height, 0.0);
              vec3 dy = vec3(0.0, heightY - height, u_delta.y);
              vec2 offset = -normalize(cross(dy, dx)).xz;
              float specular = pow(max(0.0, dot(offset, normalize(vec2(-0.6, 1.0)))), 4.0);
              vec2 imageUv = clamp(coverUv(v_uv) + offset * u_perturbance, 0.0, 1.0);
              gl_FragColor = texture2D(u_image, imageUv) + vec4(vec3(specular), 0.0);
            }
          `,
        );

        const positionBuffer = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
        gl.bufferData(
          gl.ARRAY_BUFFER,
          new Float32Array([-1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1]),
          gl.STATIC_DRAW,
        );

        const backgroundTexture = gl.createTexture();
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, backgroundTexture);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
        gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, true);

        const resolution = window.innerWidth < 750 ? 256 : 512;
        const rippleTextures = [];
        const framebuffers = [];
        const textureFilter = linearFloatTexture ? gl.LINEAR : gl.NEAREST;
        const emptyRippleData = new Float32Array(resolution * resolution * 4);

        for (let index = 0; index < 2; index += 1) {
          const rippleTexture = gl.createTexture();
          const framebuffer = gl.createFramebuffer();

          gl.bindTexture(gl.TEXTURE_2D, rippleTexture);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, textureFilter);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, textureFilter);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
          gl.texImage2D(
            gl.TEXTURE_2D,
            0,
            gl.RGBA,
            resolution,
            resolution,
            0,
            gl.RGBA,
            gl.FLOAT,
            emptyRippleData,
          );
          gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
          gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, rippleTexture, 0);

          if (gl.checkFramebufferStatus(gl.FRAMEBUFFER) !== gl.FRAMEBUFFER_COMPLETE) {
            throw new Error('Wave framebuffer is unavailable.');
          }

          rippleTextures.push(rippleTexture);
          framebuffers.push(framebuffer);
        }

        const intensity = Number.parseFloat(this.dataset.waveIntensity) || 0.65;
        const uniforms = {
          drop: {
            texture: gl.getUniformLocation(dropProgram, 'u_texture'),
            center: gl.getUniformLocation(dropProgram, 'u_center'),
            radius: gl.getUniformLocation(dropProgram, 'u_radius'),
            strength: gl.getUniformLocation(dropProgram, 'u_strength'),
          },
          update: {
            texture: gl.getUniformLocation(updateProgram, 'u_texture'),
            delta: gl.getUniformLocation(updateProgram, 'u_delta'),
          },
          render: {
            image: gl.getUniformLocation(renderProgram, 'u_image'),
            ripples: gl.getUniformLocation(renderProgram, 'u_ripples'),
            delta: gl.getUniformLocation(renderProgram, 'u_delta'),
            containerRatio: gl.getUniformLocation(renderProgram, 'u_container_ratio'),
            perturbance: gl.getUniformLocation(renderProgram, 'u_perturbance'),
            viewportAspect: gl.getUniformLocation(renderProgram, 'u_viewport_aspect'),
            imageAspect: gl.getUniformLocation(renderProgram, 'u_image_aspect'),
            focalPoint: gl.getUniformLocation(renderProgram, 'u_focal_point'),
          },
        };
        let previousPointerTime = 0;
        let previousFrameTime = 0;
        let lastInteractionTime = Number.NEGATIVE_INFINITY;
        let activePointerId = null;
        let lastDragPoint = null;
        let writeIndex = 0;
        let readIndex = 1;
        let loadedSource = '';

        const drawQuad = (program) => {
          gl.useProgram(program);
          gl.bindBuffer(gl.ARRAY_BUFFER, positionBuffer);
          const positionLocation = gl.getAttribLocation(program, 'a_position');
          gl.enableVertexAttribArray(positionLocation);
          gl.vertexAttribPointer(positionLocation, 2, gl.FLOAT, false, 0, 0);
          gl.drawArrays(gl.TRIANGLES, 0, 6);
        };

        const swapBuffers = () => {
          writeIndex = 1 - writeIndex;
          readIndex = 1 - readIndex;
        };

        const resize = () => {
          const pixelRatio = Math.min(window.devicePixelRatio || 1, window.innerWidth < 750 ? 1 : 1.35);
          const width = Math.max(1, Math.round(this.canvas.clientWidth * pixelRatio));
          const height = Math.max(1, Math.round(this.canvas.clientHeight * pixelRatio));

          if (this.canvas.width === width && this.canvas.height === height) return;

          this.canvas.width = width;
          this.canvas.height = height;
          gl.viewport(0, 0, width, height);
        };

        const uploadImage = () => {
          if (!this.image.complete || this.image.naturalWidth === 0) return false;

          try {
            gl.activeTexture(gl.TEXTURE0);
            gl.bindTexture(gl.TEXTURE_2D, backgroundTexture);
            gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, this.image);
            loadedSource = this.image.currentSrc || this.image.src;
            return true;
          } catch (error) {
            this.classList.remove('voy-coming-soon__media--wave-ready');
            return false;
          }
        };

        const updateRipples = () => {
          gl.viewport(0, 0, resolution, resolution);
          gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffers[writeIndex]);
          gl.activeTexture(gl.TEXTURE0);
          gl.bindTexture(gl.TEXTURE_2D, rippleTextures[readIndex]);
          gl.useProgram(updateProgram);
          gl.uniform1i(uniforms.update.texture, 0);
          gl.uniform2f(uniforms.update.delta, 1 / resolution, 1 / resolution);
          drawQuad(updateProgram);
          swapBuffers();
        };

        const addPointerRipple = (clientX, clientY, radiusScale = 1, strength = 0.01) => {
          const bounds = this.canvas.getBoundingClientRect();
          const x = (clientX - bounds.left) / bounds.width;
          const y = 1 - (clientY - bounds.top) / bounds.height;
          const longestSide = Math.max(bounds.width, bounds.height);
          const centerX = 0.5 + (x - 0.5) * (bounds.width / longestSide);
          const centerY = 0.5 + (y - 0.5) * (bounds.height / longestSide);
          const dropRadius = window.innerWidth < 750 ? 10 : 15;
          const radius = (dropRadius * radiusScale) / longestSide;

          gl.viewport(0, 0, resolution, resolution);
          gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffers[writeIndex]);
          gl.activeTexture(gl.TEXTURE0);
          gl.bindTexture(gl.TEXTURE_2D, rippleTextures[readIndex]);
          gl.useProgram(dropProgram);
          gl.uniform1i(uniforms.drop.texture, 0);
          gl.uniform2f(uniforms.drop.center, centerX, centerY);
          gl.uniform1f(uniforms.drop.radius, radius);
          gl.uniform1f(uniforms.drop.strength, strength);
          drawQuad(dropProgram);
          swapBuffers();
          lastInteractionTime = performance.now();
          startRendering();
        };

        const normalizePosition = (value, fallback) => {
          if (value === 'left' || value === 'top') return 0;
          if (value === 'right' || value === 'bottom') return 1;
          if (value === 'center') return 0.5;

          const numericValue = Number.parseFloat(value);
          return Number.isFinite(numericValue) ? numericValue / 100 : fallback;
        };

        const getFocalPoint = () => {
          const position = window.getComputedStyle(this.image).objectPosition.split(' ');
          return [normalizePosition(position[0], 0.5), normalizePosition(position[1], 0.5)];
        };

        this.canvas.addEventListener(
          'pointermove',
          (event) => {
            const isDirectPointer = event.pointerType !== 'mouse';
            const isActiveDrag = event.pointerId === activePointerId;

            if (isDirectPointer && !isActiveDrag) return;

            const now = performance.now();
            const minimumInterval = isActiveDrag ? 32 : 16;

            if (now - previousPointerTime < minimumInterval) return;

            previousPointerTime = now;

            if (!isActiveDrag) {
              addPointerRipple(event.clientX, event.clientY);
              return;
            }

            const nextPoint = { x: event.clientX, y: event.clientY };
            const previousPoint = lastDragPoint || nextPoint;
            const distance = Math.hypot(nextPoint.x - previousPoint.x, nextPoint.y - previousPoint.y);

            if (distance < 7) return;

            if (distance > 48) {
              addPointerRipple(
                previousPoint.x + (nextPoint.x - previousPoint.x) * 0.5,
                previousPoint.y + (nextPoint.y - previousPoint.y) * 0.5,
                1.2,
                0.04,
              );
            }

            addPointerRipple(nextPoint.x, nextPoint.y, 1.2, 0.055);
            lastDragPoint = nextPoint;
          },
          { signal: this.abortController.signal },
        );
        this.canvas.addEventListener(
          'pointerdown',
          (event) => {
            if (!event.isPrimary) return;

            activePointerId = event.pointerId;
            lastDragPoint = { x: event.clientX, y: event.clientY };
            previousPointerTime = performance.now();
            this.canvas.setPointerCapture(event.pointerId);
            addPointerRipple(event.clientX, event.clientY, 1.5, 0.14);
          },
          { signal: this.abortController.signal },
        );

        const endPointerDrag = (event) => {
          if (event.pointerId !== activePointerId) return;

          if (event.type === 'pointerup' && lastDragPoint) {
            const distance = Math.hypot(event.clientX - lastDragPoint.x, event.clientY - lastDragPoint.y);

            if (distance >= 7) addPointerRipple(event.clientX, event.clientY, 1.2, 0.055);
          }

          if (this.canvas.hasPointerCapture(event.pointerId)) {
            this.canvas.releasePointerCapture(event.pointerId);
          }

          activePointerId = null;
          lastDragPoint = null;
        };

        this.canvas.addEventListener('pointerup', endPointerDrag, { signal: this.abortController.signal });
        this.canvas.addEventListener('pointercancel', endPointerDrag, { signal: this.abortController.signal });
        this.canvas.addEventListener(
          'lostpointercapture',
          (event) => {
            if (event.pointerId !== activePointerId) return;

            activePointerId = null;
            lastDragPoint = null;
          },
          { signal: this.abortController.signal },
        );

        this.resizeObserver = new ResizeObserver(resize);
        this.resizeObserver.observe(this.canvas);
        resize();

        if (!uploadImage()) return;

        const render = (now) => {
          this.animationFrame = null;

          if (document.hidden) return;

          if (now - previousFrameTime < 16) {
            this.animationFrame = window.requestAnimationFrame(render);
            return;
          }

          const currentSource = this.image.currentSrc || this.image.src;
          if (currentSource !== loadedSource && !uploadImage()) return;

          previousFrameTime = now;
          const focalPoint = getFocalPoint();
          const longestSide = Math.max(this.canvas.clientWidth, this.canvas.clientHeight);

          updateRipples();
          gl.bindFramebuffer(gl.FRAMEBUFFER, null);
          gl.viewport(0, 0, this.canvas.width, this.canvas.height);
          gl.activeTexture(gl.TEXTURE0);
          gl.bindTexture(gl.TEXTURE_2D, backgroundTexture);
          gl.activeTexture(gl.TEXTURE1);
          gl.bindTexture(gl.TEXTURE_2D, rippleTextures[readIndex]);
          gl.useProgram(renderProgram);
          gl.uniform1i(uniforms.render.image, 0);
          gl.uniform1i(uniforms.render.ripples, 1);
          gl.uniform2f(uniforms.render.delta, 1 / resolution, 1 / resolution);
          gl.uniform2f(
            uniforms.render.containerRatio,
            this.canvas.clientWidth / longestSide,
            this.canvas.clientHeight / longestSide,
          );
          gl.uniform1f(uniforms.render.perturbance, 0.004 * (intensity / 0.65));
          gl.uniform1f(
            uniforms.render.viewportAspect,
            this.canvas.clientWidth / this.canvas.clientHeight,
          );
          gl.uniform1f(
            uniforms.render.imageAspect,
            this.image.naturalWidth / this.image.naturalHeight,
          );
          gl.uniform2f(uniforms.render.focalPoint, focalPoint[0], focalPoint[1]);
          drawQuad(renderProgram);
          this.classList.add('voy-coming-soon__media--wave-ready');

          if (now - lastInteractionTime < 8000) {
            this.animationFrame = window.requestAnimationFrame(render);
          }
        };

        const startRendering = () => {
          if (!this.animationFrame) this.animationFrame = window.requestAnimationFrame(render);
        };

        startRendering();
      } catch (error) {
        this.classList.remove('voy-coming-soon__media--wave-ready');
      }
    }

    #createProgram(gl, vertexSource, fragmentSource) {
      const compileShader = (type, source) => {
        const shader = gl.createShader(type);
        gl.shaderSource(shader, source);
        gl.compileShader(shader);

        if (!gl.getShaderParameter(shader, gl.COMPILE_STATUS)) {
          throw new Error(gl.getShaderInfoLog(shader));
        }

        return shader;
      };

      const program = gl.createProgram();
      gl.attachShader(program, compileShader(gl.VERTEX_SHADER, vertexSource));
      gl.attachShader(program, compileShader(gl.FRAGMENT_SHADER, fragmentSource));
      gl.linkProgram(program);

      if (!gl.getProgramParameter(program, gl.LINK_STATUS)) {
        throw new Error(gl.getProgramInfoLog(program));
      }

      return program;
    }
  }

  if (!customElements.get('voy-still-wave')) {
    customElements.define('voy-still-wave', VoyStillWave);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voy-header"] && !Shopify.designMode) return;
  try {
    
  class VoyStickyHeader extends HTMLElement {
    #controller;
    #announcementHeight = 0;

    connectedCallback() {
      if (!this.classList.contains('voy-sticky-header--overlay')) return;

      this.#controller?.abort();
      this.#controller = new AbortController();
      const options = { passive: true, signal: this.#controller.signal };

      window.addEventListener('scroll', this.#update, options);
      window.addEventListener('resize', this.#measure, options);
      this.#measure();
    }

    disconnectedCallback() {
      this.#controller?.abort();
    }

    #measure = () => {
      this.#announcementHeight = this.querySelector('.voy-header__announcements')?.offsetHeight ?? 0;
      this.#update();
    };

    #update = () => {
      this.classList.toggle('voy-sticky-header--scrolled', window.scrollY >= this.#announcementHeight);
    };
  }

  if (!customElements.get('voy-sticky-header')) {
    customElements.define('voy-sticky-header', VoyStickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voy-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  class VoyNewsletterPopup extends HTMLElement {
    #controller = new AbortController();
    #dialog;
    #storageKey = 'voyPopupDismissed';

    connectedCallback() {
      this.#dialog = this.querySelector('dialog');
      if (!this.#dialog || typeof this.#dialog.showModal !== 'function') return;

      for (const button of this.querySelectorAll('[data-voy-popup-close]')) {
        button.addEventListener('click', () => this.#close(), { signal: this.#controller.signal });
      }

      this.#dialog.addEventListener('click', (event) => this.#handleBackdropClick(event), {
        signal: this.#controller.signal,
      });
      this.#dialog.addEventListener('cancel', () => this.#rememberDismissal(), {
        signal: this.#controller.signal,
      });

      if (this.#wasDismissed() && !window.Shopify?.designMode) return;

      const delay = window.Shopify?.designMode ? 250 : Number.parseInt(this.dataset.delay || '0', 10);
      window.setTimeout(() => {
        if (this.isConnected && !this.#dialog.open) this.#dialog.showModal();
      }, delay);
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    #close() {
      this.#rememberDismissal();
      this.#dialog.close();
    }

    #handleBackdropClick(event) {
      const bounds = this.#dialog.getBoundingClientRect();
      const isOutside =
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom;

      if (isOutside) this.#close();
    }

    #rememberDismissal() {
      try {
        window.sessionStorage.setItem(this.#storageKey, 'true');
      } catch (error) {
        return;
      }
    }

    #wasDismissed() {
      try {
        return window.sessionStorage.getItem(this.#storageKey) === 'true';
      } catch (error) {
        return false;
      }
    }
  }

  if (!customElements.get('voy-newsletter-popup')) {
    customElements.define('voy-newsletter-popup', VoyNewsletterPopup);
  }

  } catch(e) { console.error(e); }
})();
})();
